import { JsonForms } from '@jsonforms/react';
import { QCUploadEDTF } from '@shared/types/ImagingSpecialist';
import { twJoin } from 'tailwind-merge';
import { combineDisplayRenderers } from './renderers';
import React, { FC, useMemo } from 'react';
import './styles.scss';

type EDTFDisplayFormProps = {
  data: QCUploadEDTF;
  dark?: boolean;
};

export const EDTFDisplayForm: FC<EDTFDisplayFormProps> = ({ data, dark }) => {
  const { cells, renderers } = useMemo(() => {
    return combineDisplayRenderers(dark);
  }, [dark]);

  if (!data) {
    return null;
  }

  return (
    <div className={twJoin('px-[10px]', dark && 'dark-theme text-white')}>
      <JsonForms
        schema={data.schema}
        uischema={data.uiSchema}
        data={data.data}
        renderers={renderers}
        cells={cells}
        readonly={true}
      />
    </div>
  );
};
